export default class ErrorHelper {
  static handleError<T extends Error>(error: T): void {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}
